<template>
  <div>
    <canvas :id="canvaId"></canvas>
    <CRow class="mt-2">
      <CCol col="3" class="text-center">
        <div>
          <CashIcon size="32" class="text-info" />
        </div>
        <div>
          <span>${{ formatter.format(totalSales, 2) }}M</span>
        </div>
        <div>
          <span>Ventas</span>
        </div>
      </CCol>
      <CCol col="3" class="text-center">
        <div>
          <FileDollarIcon size="32" class="text-s3yellow" />
        </div>
        <div>
          <span>${{ formatter.format(totalCosts, 2) }}M</span>
        </div>
        <div>
          <span>Costos</span>
        </div>
      </CCol>
      <CCol col="3" class="text-center">
        <div>
          <CoinIcon size="32" class="text-success" />
        </div>
        <div>
          <span>${{ formatter.format((totalSales - totalCosts), 2) }}M</span>
        </div>
        <div>
          <span>Utilidad</span>
        </div>
      </CCol>
      <CCol col="3" class="text-center">
        <div>
          <ReceiptTaxIcon size="32" class="text-s3turquoise" />
        </div>
        <div>
          <span>{{ formatter.format(((totalSales - totalCosts) / totalSales) * 100, 2) }}%</span>
        </div>
        <div>
          <span>Margen</span>
        </div>
      </CCol>
    </CRow>

    <LoadingCover spinner="dotsbar" v-show="loading" />
  </div>
</template>
<script>
  import moment from "moment";
  import { Chart } from "chart.js";
  import { formatter } from "@/general";
  import CONSTANTS from "@/constants";
  import { dataVentasMensual } from "@/apis/sales";

  import LoadingCover from "@/components/containers/LoadingCover.vue";

  export default {
    name: "MonthlySalesParticipationChart",
    data() {
      return {
        moment,
        formatter,
        loading: false,
        canvaId: "",
        nameMonths: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
        dataMonthlySalesParticipation: [],
        totalSales: 0,
        totalCosts: 0,
        utility: 0
      }
    },
    props: {
      title: String,
      initialDate: String,
      finalDate: String,
      utilityType: String,
      branch: String,
      employeeGroup: String,
      employee: String,
      valuesDivisor: Number,
      valuesSing: String
    },
    components: {
      LoadingCover
    },
    methods: {
      async getDataMonthlySalesParticipation() {
        try {
          const parameters = {
            "Fecha_Inicial": this.initialDate,
            "Fecha_Final": this.finalDate,
            "Id_Sucursal": this.branch,
            "Id_GrupoEmpleado": this.employeeGroup,
            "Id_Empleado": this.employee
          }
          const { response } = await dataVentasMensual(this, parameters);
          this.dataMonthlySalesParticipation = response;
          this.dataMonthlySalesParticipation.map(item => {
            this.totalSales += item.Valor_Mercancia;
            this.totalCosts += item.Costo_Mercancia;
          });

          this.totalSales = (this.totalSales / this.valuesDivisor);
          this.totalCosts = (this.totalCosts / this.valuesDivisor)
        } catch (error) {
          console.log(error)          
        }
      },
      setupChart() {
        let optionsChart = {
          responsive: true,
          maintainAspectRadio: false,
          interaction: {
              mode: "index",
              intersect: false
          },
          scales: {
            x: {
              offset: true,
              grid: {
                display: false
              }
            }
          },
          plugins: {
            title: {
              display: true,
              text: this.title
            },
            legend: {
              display: true,
              position: "top",
              labels: {
                boxWidth: 5,
                boxHeight: 5,
                font: {
                  size: 10
                }
              }
            },
            tooltip: {
              enabled: true,
              position: "nearest",
              usePointStyle: true,
              padding: 12,
              borderwidth: 1,
              backgroundColor: "midnightblue",
              callbacks: {
                label : function (context) {
                  return `$${context.formattedValue}M`;
                }
              },
              itemSort: function(a, b) {
                return b.parsed.y - a.parsed.y;
              }
            }
          }
        }

        const chart = new Chart(document.getElementById(this.canvaId), {
          type: "bar",
          data: {
            labels: this.dataMonthlySalesParticipation.map(data => this.nameMonths[data.Mes - 1]),
            datasets: [
              {
                type: "bar",
                label: "Ventas",
                order: 1,
                data: this.dataMonthlySalesParticipation.map(data => Math.round((data.Valor_Mercancia / this.valuesDivisor) * 100) / 100),
                backgroundColor: CONSTANTS.colors.color01,
                datalabels: {
                  display: false
                }
              },
              {
                type: "line",
                label: "Costos",
                order: 0,
                data: this.dataMonthlySalesParticipation.map(data => Math.round((data.Costo_Mercancia / this.valuesDivisor) * 100) / 100),
                backgroundColor: CONSTANTS.colors.color15,
                datalabels: {
                  display: true,
                  anchor: 'end',
                  align: 'top',
                  formatter: (value, context) => {
                    return `${this.dataMonthlySalesParticipation[context.dataIndex]["Utilidad"]}%`;
                  }
                }
              }
            ]
          },
          options: optionsChart
        });

        chart.update();
      }
    },
    async mounted() {
      this.loading = true;

      try {
        this.canvaId = crypto.randomUUID();

        await this.getDataMonthlySalesParticipation();
        this.setupChart();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    }
  }
</script>
